import * as React from 'react';

export const invokeRefFunction = (refObject: React.RefObject<(() => void) | null>) => {
  if (typeof refObject.current === 'function') {
    refObject.current();
  }
};
